
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/2023-material-ui-v6-and-beyond",
      function () {
        return require("private-next-pages/blog/2023-material-ui-v6-and-beyond.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/2023-material-ui-v6-and-beyond"])
      });
    }
  